<div *ngIf="locationConfigFG; else loading">
  <header class="config-status-header mb-4">
    <div class="header-main-row">
      <div class="title-group">
        <h1 class="mat-headline-medium">{{ mode }} Merchant</h1>
        <span class="id-badge" *ngIf="mode === 'Update'">
          <mat-icon inline>fingerprint</mat-icon>
            {{ locationConfigFG.get('id')?.value }}
        </span>
      </div>

      <div class="metadata mat-body-2" *ngIf="mode === 'Update'">
        <div class="meta-item">
          <span class="meta-label">Last Modified By:</span>
          <span class="meta-value">{{ locationConfigFG.get('lastModifiedBy')?.value || 'System' }}</span>
        </div>
        <div class="meta-item">
          <span class="meta-label">Last Modified At:</span>
          <span class="meta-value">{{ formatUtcIsoStringToLocal(locationConfigFG.get('lastModifiedDateTime')?.value) }}</span>
        </div>
      </div>
    </div>
    <mat-divider></mat-divider>
  </header>

  <form [formGroup]="locationConfigFG" class="location-form-container">
    <mat-card class="mb-4">
      <mat-card-header>
        <mat-card-title>Location Settings</mat-card-title>
      </mat-card-header>

      <mat-card-content class="form-grid-2-col">
        <mat-form-field appearance="outline">
          <mat-label>Location ID</mat-label>
          <input matInput formControlName="id">
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="isDojo">
          <mat-label>Customer ID</mat-label>
          <input matInput formControlName="customerId">
        </mat-form-field>
      </mat-card-content>

      <mat-card-content class="form-grid">
        <mat-form-field appearance="outline">
          <mat-label>Status</mat-label>
          <mat-select formControlName="status">
            <mat-option *ngFor="let status of statuses" [value]="status">
              {{status}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Gateway</mat-label>
          <mat-select formControlName="gatewayName">
            <mat-option *ngFor="let g of gatewayOptions" [value]="g">
              {{ g }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Gateway Username</mat-label>
          <input matInput formControlName="gatewayUsername" placeholder="e.g. user_123">
          <mat-error *ngIf="locationConfigFG.get('gatewayUsername')?.hasError('required')">
            Username is required for PayVector integration.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline"
                        *ngIf="locationConfigFG.get('gatewayName')?.value == Gateway.PayVector">
          <mat-label>Gateway Password</mat-label>
          <input matInput formControlName="editableGatewayPassword"
                 type="password"
                 placeholder="Leave blank to clear">
        </mat-form-field>
      </mat-card-content>
    </mat-card>

    <mat-card class="mb-4" *ngIf="locationConfigFG.get('gatewayName')?.value !== Gateway.PayVector">
      <mat-card-header>
        <mat-card-title>Digital Wallets</mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="checkbox-group">
          <mat-slide-toggle formControlName="isApplePayEnabled">Enable Apple Pay</mat-slide-toggle>
          <mat-slide-toggle formControlName="isGooglePayEnabled">Enable Google Pay</mat-slide-toggle>
          <mat-slide-toggle formControlName="isAlipayEnabled"
                        *ngIf="isDojo">
            Enable Alipay
          </mat-slide-toggle>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="mb-4">
      <mat-card-header>
        <mat-card-title>Features</mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="checkbox-group">
          <mat-slide-toggle formControlName="isMerchantInitiatedTransactionsEnabled">Enable Merchant Initiated Transactions</mat-slide-toggle>
          <mat-slide-toggle formControlName="isMotoEnabled">Enable MOTO</mat-slide-toggle>
          <mat-slide-toggle formControlName="isMotoAllowedWithoutCVV">Allow MOTO Without CVV</mat-slide-toggle>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- AMEX configuration -->
    <mat-card class="mb-4">
      <mat-card-header>
        <mat-card-title>American Express</mat-card-title>
      </mat-card-header>

      <mat-card-content class="form-grid">
        <mat-form-field appearance="outline">
          <mat-label>Account Type</mat-label>
          <mat-select formControlName="amexAccountType">
            <mat-option *ngFor="let opt of amexAccountTypes" [value]="opt">
              {{ opt }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Only required/visible if amex account type is 'Direct' -->
        <mat-form-field appearance="outline" *ngIf="locationConfigFG.get('amexAccountType')?.value === AmexAccountType.Direct">
          <mat-label>Amex Ecom SE Number</mat-label>
          <input matInput formControlName="amexEcomSENumber" placeholder="10-digit Service Establishment number">
          <mat-error *ngIf="locationConfigFG.get('amexEcomSENumber')?.hasError('required')">
            Ecom SE Number is required for Direct Amex integration.
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" *ngIf="locationConfigFG.get('amexAccountType')?.value === AmexAccountType.Direct">
          <mat-label>Amex F2F SE Number</mat-label>
          <input matInput formControlName="amexF2FSENumber" placeholder="10-digit Service Establishment number">
          <mat-error *ngIf="locationConfigFG.get('amexF2FSENumber')?.hasError('required')">
            F2F SE Number is required for Direct Amex integration.
          </mat-error>
        </mat-form-field>
      </mat-card-content>
    </mat-card>

    <mat-card class="mb-4">
      <mat-card-header>
        <mat-card-title>Location Details</mat-card-title>
      </mat-card-header>
      <mat-card-content class="form-grid">
        <mat-form-field appearance="outline">
          <mat-label>Remote Terminal ID</mat-label>
          <input matInput formControlName="remoteTerminalId">
          <mat-error>Remote Terminal ID is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Location Name</mat-label>
          <input matInput formControlName="name">
          <mat-error>Name is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Description</mat-label>
          <input matInput formControlName="description">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Phone Number</mat-label>
          <input matInput formControlName="phoneNumber">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Email Address</mat-label>
          <input matInput formControlName="emailAddress">
          <mat-error>Valid email is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Partner Name</mat-label>
          <input matInput formControlName="partnerName">
          <mat-error>Valid partner name is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>URL</mat-label>
          <input matInput formControlName="url">
          <mat-error>Valid URL is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>MCC</mat-label>
          <input matInput formControlName="merchantCategoryCode"
                 [matAutocomplete]="autoMcc">
        </mat-form-field>
        <mat-autocomplete #autoMcc="matAutocomplete">
          <mat-option *ngFor="let mcc of filteredMccOptions | async" [value]="mcc.mcc">
            {{ mcc.mcc }} - {{ mcc.text }}
          </mat-option>
        </mat-autocomplete>

        <mat-form-field appearance="outline">
          <mat-label>Address 1</mat-label>
          <input matInput formControlName="address1">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Address 2</mat-label>
          <input matInput formControlName="address2">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>City</mat-label>
          <input matInput formControlName="city">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>State</mat-label>
          <input matInput formControlName="state">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Postcode</mat-label>
          <input matInput formControlName="postcode">
          <mat-error>Valid Postcode is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="extra-hint-space">
          <mat-label>Country Code</mat-label>
          <input matInput formControlName="countryCode"
                 [maxLength]="2"
                 [matAutocomplete]="countryCodeAutocomplete">
          <mat-autocomplete #countryCodeAutocomplete="matAutocomplete">
            <mat-option *ngFor="let kcc of knownCountryCodes" [value]="kcc">
              {{ kcc }}
            </mat-option>
          </mat-autocomplete>
          <mat-hint>The two-letter ISO 3166 country code, e.g. GB for the United Kingdom.
            It defaults to GB if not provided or if provided an invalid country code</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Market ID</mat-label>
          <input matInput formControlName="marketId">
        </mat-form-field>
      </mat-card-content>
    </mat-card>

    <mat-card class="mb-4">
      <mat-card-header>
        <mat-card-title>API Management</mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div formArrayName="apiKeys">
          <div *ngFor="let keyGroup of apiKeys.controls; let i=index"
               [formGroupName]="i" class="api-key-row">

            <mat-form-field appearance="outline" class="key-id-field">
              <mat-label>Key ID</mat-label>
              <input matInput formControlName="key" placeholder="Enter Key ID">
            </mat-form-field>

            <mat-slide-toggle formControlName="enabled" class="status-toggle-wrapper">
              {{ keyGroup.get('enabled')?.value ? 'Active' : 'Inactive' }}
            </mat-slide-toggle>

            <button type="button" mat-icon-button color="accent" (click)="generateJWT(i)" class="row-actions"
                    matTooltip="Generate and Copy JWT">
              <mat-icon>content_copy</mat-icon>
            </button>

            <button type="button" mat-icon-button color="warn" class="row-actions"
                    (click)="removeKey(i)"
                    [disabled]="!keyGroup.get('isNew').value"
                    matTooltip="Remove API Key">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
        <button type="button" mat-button color="primary" (click)="addKey()">
          <mat-icon>add</mat-icon> Add New Key
        </button>
      </mat-card-content>
    </mat-card>

    <mat-card class="mb-4" *ngIf="hasApplePay">
      <mat-card-header>
        <mat-card-title>Apple Pay Domain Names</mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <mat-chip-grid #chipList aria-label="Domain Name selection">
          <mat-chip-row
            *ngFor="let domainName of domainNames"
            [removable]="isEnabled('domainName')"
            (removed)="removeDomainName(domainName)"
            [disabled]="!isEnabled('domainName')">
            <mat-icon class="domain-registered-icon" *ngIf="isDomainRegistered(domainName)">verified_user</mat-icon>
            <mat-icon class="domain-registered-icon" *ngIf="!isDomainRegistered(domainName)">error</mat-icon>
            {{domainName}}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip-row>
          <input
            placeholder="New domain name..."
            #domainNameInput
            [formControl]="domainNamesCtrl"
            [matChipInputFor]="chipList"
            (matChipInputTokenEnd)="addDomainName($event)"
            [disabled]="isViewer">
        </mat-chip-grid>
        <mat-hint>Use comma, space, tab or enter for a valid input</mat-hint>
      </mat-card-content>
    </mat-card>

    <mat-card class="mb-4" *ngIf="hasApplePay">
      <mat-card-header>
        <mat-card-title>Apple Pay Processing Certificates</mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <mat-table [dataSource]="applePayPPC" fxFill>
          <ng-container matColumnDef="merchantId">
            <mat-header-cell *matHeaderCellDef>Apple Merchant ID</mat-header-cell>
            <mat-cell *matCellDef="let cert">{{ cert.appleMerchantId }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="created">
            <mat-header-cell *matHeaderCellDef>Created</mat-header-cell>
            <mat-cell *matCellDef="let cert">{{ cert.creationDateTime }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="expires">
            <mat-header-cell *matHeaderCellDef>Expires</mat-header-cell>
            <mat-cell *matCellDef="let cert">{{ cert.expirationDateTime }}</mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="['merchantId', 'created', 'expires']"></mat-header-row>
          <mat-row *matRowDef="let row; columns: ['merchantId', 'created', 'expires'];"></mat-row>
        </mat-table>
      </mat-card-content>
    </mat-card>

    <mat-card-actions fxFill>
      <div fxLayout="row" fxLayoutAlign="start" fxFlex="30%">
        <a mat-raised-button
           color="primary"
           (click)="duplicateLocation()"
           [disabled]="isCreateMode || !isEnabled('duplicate_merchant') || isProcessing"
           *ngIf="isAdmin && mode === 'Update'">Duplicate</a>
      </div>

      <div fxLayout="row" fxLayoutAlign="end" fxFlex="70%">
        <a routerLink="/merchants" mat-raised-button>Cancel</a>
        <button *ngIf="isCreateMode && isEnabled('create_merchant')" color="primary" type="button" mat-raised-button (click)="submit()"
                [disabled]="isProcessing">Create</button>
        <button *ngIf="isUpdateMode && isEnabled('update_merchant')" color="primary" type="button" mat-raised-button (click)="update()"
                [disabled]="isProcessing">Update</button>
        <button *ngIf="isUpdateMode && isApplePayDomainAdder" color="primary" type="button" mat-raised-button (click)="updateAddDomainNames()"
                [disabled]="isProcessing">Update Domain Names</button>
      </div>
    </mat-card-actions>
  </form>
</div>

<ng-template #loading>
  <mat-spinner></mat-spinner>
</ng-template>
